<template>
  <el-dialog
    :visible="isVisible"
    @close="hide"
    :title="title"
    :destroy-on-close="true"
  >
    <loading v-if="!isInitialized"></loading>
    <tag-form v-if="isInitialized" v-bind="formData" @stored="onStored"></tag-form>
  </el-dialog>
</template>

<script>
  import BaseDialogFormWrapper from '../../components/dialog-form-wrapper';
  import TagForm from '../../components/tag/form';
  import Loading from '../../components/loading';
  import eventBus from '../../event-bus';

  export default {
    extends: BaseDialogFormWrapper,

    components: {
      Loading,
      TagForm,
    },

    computed: {
      /**
       * @return {boolean}
       */
      modelExists() {
        return _.has(this.formData, 'model.id');
      },

      /**
       * @return {string}
       */
      title() {
        if (!this.isInitialized) {
          return 'Loading ...';
        } else if (this.modelExists) {
          return 'Edit Tag';
        }

        return 'Create Tag';
      },
    },

    methods: {
      /**
       * @param {string|undefined} message
       */
      onStored({message}) {
        _.isString(message) && this.$message.success(message);
        this.hide();
        eventBus.$emit('refresh-tag-table');
      },
    },

    created() {
      eventBus.$on('show-tag-form-dialog', this.show);
    },

    beforeDestroy() {
      eventBus.$off('show-tag-form-dialog', this.show);
    }
  }
</script>
